module.exports = __webpack_public_path__ + "static/media/arrow-left.e53c611f.svg";